import { useState } from "react";
import { AiFillEye, AiFillGithub } from "react-icons/ai";
import { motion, useInView } from "framer-motion";

import { Tab } from "../../components";
import { filtersData } from "../../utils";
import { MainPageWrap } from "../../wrapper";
import { useMediaQuery } from "../../hooks/useMediaQuery";

import "./Portfolio.scss";
import { useEffect } from "react";
import { client, urlFor } from "../../client";
import { useRef } from "react";
import { sectionVariants } from "../../utils/animation";

const Portfolio = ({ handleActiveIndex }) => {
  const [projectsData, setProjectsData] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });
  const isLarge = useMediaQuery("(min-width: 480px)");
  const portfolioRef = useRef();
  const isInView = useInView(portfolioRef);

  useEffect(() => {
    if (isInView) {
      handleActiveIndex(2);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInView]);

  const projectsVariants = {
    hidden: {
      opacity: 0,
      x: -100,
    },
    visible: (custom) => ({
      opacity: 1,
      x: 0,
      transition: {
        type: "spring",
        delay: (custom / 2) * 0.2,
      },
    }),
  };

  const fetchProjects = async (projectsQuery) => {
    try {
      const response = await client.fetch(projectsQuery);
      const data = await response;
      setProjectsData(data);
      setFilteredProjects(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const query = '*[_type == "works"]';
    fetchProjects(query);
  }, []);

  return (
    <motion.div
      ref={portfolioRef}
      initial="hidden"
      whileInView="visible"
      variants={sectionVariants}
      viewport={{ once: true }}
      className="portfolio"
    >
      <div className="portfolio__title title">
        My Creative <span>Portfolio</span> Section
      </div>
      <div className="portfolio__filter">
        <Tab
          setFilteredProjects={setFilteredProjects}
          data={projectsData}
          filters={filtersData}
          setAnimateCard={setAnimateCard}
        />
      </div>
      <motion.div
        className="portfolio__items"
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        key={isLarge}
      >
        {filteredProjects &&
          filteredProjects.map((project, index) => {
            const {
              _id,
              title,
              description,
              tags,
              imgUrl,
              codeLink,
              projectLink,
            } = project;

            return (
              <motion.div
                initial="hidden"
                whileInView="visible"
                variants={projectsVariants}
                custom={index + 1}
                key={_id}
                className="portfolio__item item"
              >
                <div className="item__image-block">
                  <img src={urlFor(imgUrl)} alt={title} className="item__img" />
                  <motion.div
                    className="item__links"
                    whileHover={isLarge && { opacity: [0, 1] }}
                    transition={{
                      duration: 0.25,
                      ease: "easeInOut",
                      staggerChildren: 0.5,
                    }}
                  >
                    <a
                      href={projectLink}
                      target="_blank"
                      className="item__link"
                      rel="noreferrer"
                    >
                      <motion.div
                        className="item__live"
                        whileInView={{ scale: [0, 1] }}
                        whileHover={{ scale: [1, 0.9] }}
                        transition={{ duration: 0.25 }}
                      >
                        <AiFillEye />
                      </motion.div>
                    </a>
                    <a
                      href={codeLink}
                      target="_blank"
                      className="item__link"
                      rel="noreferrer"
                    >
                      <motion.div
                        className="item__source"
                        whileInView={{ scale: [0, 1] }}
                        whileHover={{ scale: [1, 0.9] }}
                        transition={{ duration: 0.25 }}
                      >
                        <AiFillGithub />
                      </motion.div>
                    </a>
                  </motion.div>
                  <div className="item__tag">
                    <p className="p-text">{tags[0]}</p>
                  </div>
                </div>
                <div className="item__content">
                  <h2 className="item__title">{title}</h2>
                  <p className="item__descr p-text">{description}</p>

                </div>
              </motion.div>
            );
          })}
      </motion.div>
    </motion.div>
  );
};

export default MainPageWrap(Portfolio, "portfolio");
